import TeamFilters from './TeamFilters.component';

export default TeamFilters;